import React from 'react';

import { Box, Section, Typography } from 'components';
import { useProducts } from 'features/products';
import { useSchool } from 'features/school';

const ProductHero = () => {
  const { productDetails } = useProducts();
  const { schoolAlias } = useSchool();

  return (
    <Section flexGrow={0} flexDirection="column" pt={{ m: 6, d: 116 }}>
      {!!productDetails?.product.hat && (
        <Typography type="type3" color={schoolAlias === 'b3' ? 'white80' : 'gray_500'} upper mb={2}>
          {productDetails?.product.hat}
        </Typography>
      )}

      <Typography type="type6" color="white" fontWeight="bold">
        {productDetails?.product.name}
      </Typography>

      {!!productDetails?.product.description && (
        <Box mt={{ m: 3, d: 4 }} maxWidth={{ d: 450 }}>
          <Typography type="type1" color="white" lineHeight={1.3}>
            {productDetails?.product.description}
          </Typography>
        </Box>
      )}
    </Section>
  );
};

export default ProductHero;
